/** Internal status set when IMO autofill / submission processing completes successfully. */
export const SUBMISSION_STATUS_FULFILLED = "fulfilled";
const AUTOFILL_COMPLETE = new Set(["fulfilled", "done"]);
/**
 * Labels for agent-profile surfaces (dashboard agent list, agent detail).
 * Hides internal autofill jargon — use raw status only on submission ops views.
 */
export function formatSubmissionStatusForAgentProfile(status) {
    const normalized = status.trim().toLowerCase();
    if (AUTOFILL_COMPLETE.has(normalized))
        return "Submitted";
    if (normalized === "queued")
        return "Queued";
    if (normalized === "processing")
        return "Processing";
    if (normalized === "failed")
        return "Failed";
    return status;
}
export function isSubmissionAutofillComplete(status) {
    return AUTOFILL_COMPLETE.has(status.trim().toLowerCase());
}
